module.exports = __webpack_public_path__ + "img/app-close.48c09a30.svg";